import styled from 'styled-components';

export const ErrorMsg = styled.p`
  font-size: 12px;
  color: red;
  margin-bottom: 0;
  padding: 8px 24px;
`;
